<template>
  <div class="column-container">
    <div class="toolbar">
      <div class="actions">
        <b-button size="sm" variant="outline-secondary" @click="toggleEdit" title="Attributes editor"><fa icon="bars"></fa></b-button>
        <b-button size="sm" variant="outline-secondary" @click="$emit('move-left', index)" :disabled="index === 0" v-if="siblingCount > 1"><fa icon="arrow-left"></fa></b-button>
        <b-button size="sm" variant="outline-secondary" @click="$emit('move-right', index)" :disabled="index >= siblingCount - 1" v-if="siblingCount > 1"><fa icon="arrow-right"></fa></b-button>
        <b-button size="sm" variant="outline-secondary" @click="clearContent()" :disabled="obj.children.length === 0" title="Clear column content"><fa icon="eraser"></fa></b-button>
        <b-button size="sm" variant="outline-danger" @click="$emit('remove-column', index)" class="actions--right" v-if="siblingCount > 1"><fa icon="times"></fa></b-button>
      </div>

      <div class="properties" v-if="isEditing">
<!--         <b-form-group
          label="Width"
          label-size="sm"
        >
          <b-form-select size="sm" v-model="obj.attributes.width" @change="$emit('width-changed', obj.id, obj.attributes.width)">
            <option value="100%" :disabled="!allowedWidths.includes('100%')">100%</option>
            <option value="66%" :disabled="!allowedWidths.includes('66%')">66%</option>
            <option value="50%" :disabled="!allowedWidths.includes('50%')">50%</option>
            <option value="33%" :disabled="!allowedWidths.includes('33%')">33%</option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          label="Align"
          label-size="sm"
        >
          <b-form-select size="sm" v-model="obj.attributes.align">
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
            <option value="justify">Justify</option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          label="Background Color"
          label-size="sm"
        >
          <b-form-input type="text" size="sm" v-model="obj.attributes.background.color">
        </b-form-group>

        <b-form-group
          label="Text Color"
          label-size="sm"
        >
          <b-form-input type="text" size="sm" v-model="obj.attributes.color">
        </b-form-group>

        <b-form-group
          label="Padding"
          label-size="sm"
        >
          <b-form-input type="text" size="sm" v-model="obj.attributes.padding">
        </b-form-group>
 -->
        <attribute-editor
          name="Container Attributes"
          :attributes="obj.attributes"
          @changed="attributesChanged"
        ></attribute-editor>

        <div
          v-for="child in obj.children"
          :key="child.id"
        >
          <hr>

          <attribute-editor
            name="Content Attributes"
            :attributes="child.attributes"
            @changed="contentAttributesChanged"
          ></attribute-editor>
        </div>
      </div>
    </div>

    <div class="body">
      <component
        :is="child.component"
        v-for="child in obj.children"
        :key="child.id"
        :id="child.id"
        :obj="child"
        :substitution-tags="substitutionTags"
      ></component>

      <div class="content-buttons" v-if="obj.children.length === 0">
        <b-button size="lg" variant="outline-secondary" class="content-button" @click="addContent('ContentImage')">
          <fa icon="image" size="2x"></fa>
          <div>New Image</div>
        </b-button>

        <b-button size="lg" variant="outline-secondary" class="content-button" @click="addContent('ContentText')">
          <fa icon="font" size="2x"></fa>
          <div>New Text</div>
        </b-button>

        <b-button size="lg" variant="outline-secondary" class="content-button" @click="addContent('ContentHorizontalRule')">
          <fa icon="minus" size="2x"></fa>
          <div>New Horiontal Rule</div>
        </b-button>

        <b-button size="lg" variant="outline-secondary" class="content-button" @click="addContent('ContentSpacer')">
          <fa icon="equals" size="2x"></fa>
          <div>New Spacer</div>
        </b-button>

        <b-button size="lg" variant="outline-secondary" class="content-button" @click="addContent('ContentButton')">
          <fa icon="minus-square" size="2x"></fa>
          <div>New Button</div>
        </b-button>

        <b-button size="lg" variant="outline-secondary" class="content-button" @click="addContent('ContentSocial')">
          <fa icon="share-square" size="2x"></fa>
          <div>New Social Bar</div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as elements from './elements'
import AttributeEditor from './AttributeEditor'
import ContentImage from './ContentImage'
import ContentText from './ContentText'
import ContentHorizontalRule from './ContentHorizontalRule'
import ContentSpacer from './ContentSpacer'
import ContentButton from './ContentButton'
import ContentSocial from './ContentSocial'

export default {
  name: 'ColumnContainer',

  components: {
    AttributeEditor,
    ContentImage,
    ContentText,
    ContentHorizontalRule,
    ContentSpacer,
    ContentButton,
    ContentSocial
  },

  props: [
    'obj',
    'siblingCount',
    'index',
    'substitutionTags'
  ],

  data() {
    return {
      isEditing: false
    }
  },

  computed: {
    style() {
      return this.obj.style()
    },

    allowedWidths() {
      switch (this.siblingCount) {
        case 1:
          return ['100%']
        case 2:
          return ['66%', '50%', '33%']
        case 3:
          return ['33%']
        default:
          return ['100%']
      }
    }
  },

  methods: {
    toggleEdit() {
      this.isEditing = !this.isEditing
    },

    addContent(content, ...rest) {
      this.obj.children.push(new elements[content](...rest))
    },

    clearContent() {
      if (confirm('Are you sure you want to remove the content from this column?')) {
        this.obj.children.splice(0)
      }
    },

    attributesChanged(val) {
      this.obj.attributes = val
    },

    contentAttributesChanged(val) {
      if (this.obj.children.length > 0) {
        this.obj.children[0].attributes = val
      }
    }
  }
}
</script>

<style scoped>
  .column-container {
    position: relative;
    width: 100%;

    /*border: solid 1px #CCC;*/
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0,0,0,0.5);
  }

  .toolbar {
    padding: 5px;

    border-bottom: solid 1px #CCC;
    background: #FFF;
  }

  .actions {
    display: flex;
  }

  .actions > * + * {
    margin-left: 5px;
  }

  .actions--right {
    margin-left: auto;
  }

  .body {
    padding: 10px;
  }

  .content-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
  }

  .content-button {
    border-style: dashed;
  }
</style>
